import { UseFormReturn } from 'react-hook-form';

import { LocalesEnum } from '@/constants/locales';

import {
  Ad,
  AdSortByEnum,
  Category,
  Education,
  Experience,
  Region
} from './__generated_graphql__/graphql';
import {
  CardStatus,
  EDUCATIONS,
  EXPERIENCES,
  FilterTypeEnum
} from './constants/common';

export interface CardAd extends Pick<
  Ad,
  | 'id'
  | 'updatedAt'
  | 'createdAt'
  | 'bumpedAt'
  | 'location'
  | 'salaryFrom'
  | 'salaryTo'
  | 'daysLeft'
  | 'isFeatured'
  | 'isBumped'
  | 'isMine'
  | 'paidServices'
  | '__typename'
  | 'positionName'
  | 'name'
  | 'logo'
  | 'activatable'
> {
  subtitle: Ad['positionName'];
  title: Ad['name'];
  image: Ad['logo'];
  status?: CardStatus;
  isDeactivated: boolean;
  isBookmarked?: boolean;
}

export type FormValues = {
  categories: Category[];
  regions: Region[];
  educations: Education[];
  experiences: Experience[];
  salaryFrom: number;
  salaryTo: number;
  sortBy: AdSortByEnum | null;
  searchTerm: string | null;
};

export type FormValuesKeys = keyof FormValues;

export type FiltersData = {
  name: string;
  children: JSX.Element;
  formField: FormValuesKeys | FormValuesKeys[];
  type: FilterTypeEnum;
};

export type ResultPageInitialProps = Partial<{
  categoryIds: string | string[];
  regionIds: string | string[];
  educationIds: string[];
  experienceIds: string[];
  salaryFrom: string;
  salaryTo: string;
  fromParticipant?: boolean;
  query?: string;
  sortBy?: AdSortByEnum;
  searchTerm?: string;
}>;

export type ResultPageParamsKeys = keyof ResultPageInitialProps;

export type ChipFieldName = typeof EXPERIENCES | typeof EDUCATIONS;
export type ChipForm = Pick<FormValues, ChipFieldName>;
export type ChipValues =
  | ChipForm[typeof EXPERIENCES]
  | ChipForm[typeof EDUCATIONS];

export type ChipKeys = keyof ChipForm;

export type RequiredHeaderContextProps = {
  query: string;
  formMethods: UseFormReturn<FormValues>;
  onChangeQuery: (queryValue: string) => void;
  visible?: boolean;
  onUpdateValue?: (data: Partial<FormValues>) => void;
};

export const AdStatus = {
  approved: 'approved',
  rejected: 'rejected',
  pending: 'pending',
  expired: 'expired',
  awaiting_payment: 'awaiting_payment'
} as const;

export type AdStatus = keyof typeof AdStatus;

export interface SeoMetadataPagesParams<T> {
  params: T;
}

export interface CommonPageParams {
  id: string;
  locale: string;
}

export type ResumePageParams = SeoMetadataPagesParams<CommonPageParams>;
export type VacancyPageParams = SeoMetadataPagesParams<CommonPageParams>;

export type LangCode = `${LocalesEnum}`;
export type LangPrefix = `${LangCode}.`;
